import React from 'react'

export default function Layouts500() {
  return (
    <section><a className="anchor" id="internalserver"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/internalserver.html"><img src="images/internalserver.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h2>500 Error</h2>
            <p>Live example of all the 500 error page.</p>
            <p><a className="btn btn--large" href="samples/internalserver.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/internalserver.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Layouts500.js